<template>
  <nav class="nav" ref="navRef">
    <div
      class="nav__outer"
      :class="{ 'js-visible-smooth': isOpen, 'js-hidden-smooth': !isOpen && hasInteracted }"
    >
      <div class="container">
        <ul class="nav__list">
          <li
            v-for="item in navItems"
            :key="item.link"
            class="nav__item"
            :class="{ nav_dropdown: item.children?.length }"
          >
            <a
              v-if="item.external"
              :href="item.link"
              class="nav__link"
            >{{ item.title }}</a>
            <router-link
              v-else
              :to="item.link"
              class="nav__link"
              :class="{ 'nav__link--active': isActive(item.link) }"
            >{{ item.title }}</router-link>

            <ul v-if="item.children?.length" class="nav_dropdown__menu">
              <li v-for="child in item.children" :key="child.link">
                <router-link :to="child.link" class="nav_dropdown__link">{{ child.title }}</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { useNavMenu } from '../composables/useNavMenu'
import { useNavClose } from '../composables/useNavClose'
import { useNavItems } from '../composables/useNavItems'

const navRef = ref(null)
const route = useRoute()
const { isOpen, hasInteracted } = useNavMenu()
const { navItems } = useNavItems()
useNavClose(navRef)

const isActive = (link) => link === '/' ? route.path === '/' : route.path.startsWith(link)
</script>
